import styled from 'styled-components'

export const DirectionItem = styled.li`
  margin-bottom: 8px;
  
  a {
    color: #4299e1;
    text-decoration: none;
    padding: 8px 12px;
    border-radius: 6px;
    display: block;
    transition: background-color 0.2s ease;
    
    &:hover {
      background-color: #ebf8ff;
      color: #2b6cb0;
    }
  }
`;

export const DirectionList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;